import OrdersOverview from '../features/orders/OrdersOverview';

export default function OrdersPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Siparişler</h1>
          <p>Son siparişleri inceleyin, ödeme durumlarını izleyin ve teslimatı hangi restoranın üstlendiğini görün.</p>
        </div>
      </header>

      <section className="page-section">
        <OrdersOverview />
      </section>
    </div>
  );
}
